var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hooper"},[_c('card',{attrs:{"card":_vm.card,"hide":false,"disableSwipe":true}}),_c('vue-swipe-component',{staticClass:"swipe-component",attrs:{"card":_vm.card}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }